import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import client from './client';

const KEYS = {
  all: ['notifications'],
};

export function useNotifications() {
  return useQuery({
    queryKey: KEYS.all,
    queryFn: () => client.get('/api/v1/auth/notifications/').then((r) => r.data),
    refetchInterval: 30_000,
  });
}

export function useMarkRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => client.patch(`/api/v1/auth/notifications/${id}/read/`).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEYS.all }),
  });
}

export function useMarkAllRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => client.post('/api/v1/auth/notifications/read-all/').then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEYS.all }),
  });
}

// Invitations (for settings team tab)
export function useInvitations() {
  return useQuery({
    queryKey: ['invitations'],
    queryFn: () => client.get('/api/v1/auth/invitations/').then((r) => r.data),
    refetchInterval: 60_000,
  });
}

export function useCreateInvitation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => client.post('/api/v1/auth/invitations/', data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['invitations'] }),
  });
}

export function useRevokeInvitation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => client.post(`/api/v1/auth/invitations/${id}/revoke/`).then((r) => r.data),
    // An invitation may have been accepted while its confirmation was open.
    // Refresh that stale row on both successful revocation and a conflict.
    onSettled: () => qc.invalidateQueries({ queryKey: ['invitations'] }),
  });
}
